module.exports = __webpack_public_path__ + "static/media/THREE.658a4de3.png";